import { flow } from 'lodash';
import FlipCardContainer from './FlipCardContainer';
import withUserInput from '../../hocs/UserInput';
// import withValidation from '../../hocs/Validation'; TODO uncomment and replace withPager with this if we need some sort of success messaging.
import withPager from '../../hocs/Pager';

export default flow(
  withUserInput,
  withPager
)(FlipCardContainer);



// WEBPACK FOOTER //
// ../core/src/components/FlipCards/index.js